<template>
    <div class="modal show" @click.self="$emit('close')">
        <div class="modal-dialog">
            <div class="modal-content fitbase-modal-auth">
                <div class="modal-close" @click="$emit('close')">
                    <img src="../assets/img/close.svg">
                </div>

                <div class="fitbase-login_header">
                    Войти в личный кабинет
                </div>

                <auth-form
                    :redirect-on-success="redirectOnSuccess"
                    @authenticated="onAuthenticated"
                    @no_client="onNoClient"
                />

                <div class="fitbase-modal-auth__footer">
                    <a href="https://fitbase.io/?utm_source=widget&utm_campaign=account" target="_blank" rel="noopener">
                        <img src="../assets/img/work_on_fitbase.svg" alt="Работает на FITBASE">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthForm from './AuthForm.vue'

export default {
    name: 'AuthModal',
    components: { AuthForm },
    props: {
        redirectOnSuccess: { type: Boolean, default: false },
    },
    emits: ['close', 'authenticated', 'no_client'],
    methods: {
        onAuthenticated() {
            this.$emit('authenticated')
            this.$emit('close')
        },
        onNoClient(payload) {
            this.$emit('no_client', payload)
            this.$emit('close')
        },
    },
    mounted() {
        document.body.classList.add('modal-open')
    },
    unmounted() {
        const modals = document.querySelectorAll('.modal.show')
        if (modals.length === 0) {
            document.body.classList.remove('modal-open')
        }
    },
}
</script>
